interface PaginationProps {
  page: number;
  totalPages: number;
  onChange: (page: number) => void;
}

const getPageNumbers = (page: number, total: number): (number | string)[] => {
  if (total <= 7) return Array.from({ length: total }, (_, index) => index + 1);
  const pages: (number | string)[] = [1];
  const start = Math.max(2, page - 1);
  const end = Math.min(total - 1, page + 1);
  if (start > 2) pages.push("...");
  for (let i = start; i <= end; i += 1) pages.push(i);
  if (end < total - 1) pages.push("...");
  pages.push(total);
  return pages;
};

export default function Pagination({ page, totalPages, onChange }: PaginationProps) {
  if (totalPages <= 1) return null;

  return (
    <nav aria-label="分页导航" className="mt-10 flex flex-wrap items-center justify-center gap-2">
      <button
        type="button"
        onClick={() => onChange(page - 1)}
        disabled={page === 1}
        aria-label="上一页"
        className="flex h-9 w-9 items-center justify-center rounded-md border border-background-200 text-foreground-700 transition-colors hover:border-primary-400 hover:text-primary-400 disabled:cursor-not-allowed disabled:opacity-40 disabled:hover:border-background-200 disabled:hover:text-foreground-700"
      >
        <i className="ri-arrow-left-s-line text-lg" />
      </button>

      {getPageNumbers(page, totalPages).map((item, index) =>
        typeof item === "number" ? (
          <button
            key={`page-${item}`}
            type="button"
            onClick={() => onChange(item)}
            aria-current={item === page ? "page" : undefined}
            className={`h-9 min-w-9 whitespace-nowrap rounded-md px-2 font-label text-sm transition-colors ${
              item === page
                ? "bg-primary-500 text-background-50"
                : "border border-background-200 text-foreground-700 hover:border-primary-400 hover:text-primary-400"
            }`}
          >
            {item}
          </button>
        ) : (
          <span
            key={`ellipsis-${index}`}
            className="flex h-9 min-w-6 items-center justify-center text-sm text-foreground-500"
          >
            {item}
          </span>
        ),
      )}

      <button
        type="button"
        onClick={() => onChange(page + 1)}
        disabled={page === totalPages}
        aria-label="下一页"
        className="flex h-9 w-9 items-center justify-center rounded-md border border-background-200 text-foreground-700 transition-colors hover:border-primary-400 hover:text-primary-400 disabled:cursor-not-allowed disabled:opacity-40 disabled:hover:border-background-200 disabled:hover:text-foreground-700"
      >
        <i className="ri-arrow-right-s-line text-lg" />
      </button>

      <span className="ml-2 whitespace-nowrap font-label text-xs text-foreground-500">
        第 {page} / {totalPages} 页
      </span>
    </nav>
  );
}